import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { type FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ControlErrorComponent,
  type EntityFormGroup,
  HasRequiredValidatorPipe,
} from '@pct-ng/form';
import { AbstractFormFragmentComponent } from './abstract-form-fragment.component';
import { PctNgFeatureRichTextTipTapComponent } from '@pct-ng/feature-rich-text-tip-tap';
import { WithLangPipe } from '../../pipes/name-with-lang.pipe';
import type { LanguageCode } from '../../model/language-code';

interface TitleAndContentForm {
  title: string;
  content: string;
}

type FormType = EntityFormGroup<TitleAndContentForm>;

@Component({
  selector: 'cappus-title-and-content-form-fragment',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    TranslocoDirective,
    ControlErrorComponent,
    HasRequiredValidatorPipe,
    PctNgFeatureRichTextTipTapComponent,
    WithLangPipe,
  ],
  templateUrl: './title-and-content-form-fragment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleAndContentFormFragmentComponent<
  FORM extends FormType = FormType,
> extends AbstractFormFragmentComponent<FORM> {
  readonly selectedLanguage = input.required<LanguageCode>();
  readonly submitted = input.required<boolean>();

  /**
   * Due to Angular type system we get back AbstractControl and we can't set it in the template,
   * furthermore we need the getter because of control changes, otherwise we get Angular warnings
   */
  get contentControl(): FormControl<string | null> {
    return this.parentForm().controls.content as FormControl<string | null>;
  }
}
